import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class NgSelectConfig {
  placeholder: string;
  notFoundText = "ClientApp.Projects.FrameWorkShell.Shared.Controls.NgSelect.NoPenFound";
  typeToSearchText = "ClientApp.Projects.FrameWorkShell.Shared.Controls.NgSelect.TypeToSearch";
  addTagText = "ClientApp.Projects.FrameWorkShell.Shared.Controls.NgSelect.AddPen";
  loadingText = "ClientApp.Projects.FrameWorkShell.Shared.Controls.NgSelect.Loading";
  clearAllText = "ClientApp.Projects.FrameWorkShell.Shared.Controls.NgSelect.DeleteAll";
  disableVirtualScroll = true;
  openOnEnter = true;
}
